import { useEffect, useState } from "react";
import api from "../lib/api";

const LEVELS = [["output", "Output", "What we delivered", "e.g. ₦200,000 provided to a beneficiary"], ["outcome", "Outcome", "What changed for people", "e.g. business still operating six months later"], ["impact", "Impact", "Lasting difference", "e.g. household income improved and jobs created"]];
const PERIOD_LABEL = { baseline: "Baseline", completion: "At completion", "3m": "3 months", "6m": "6 months", "12m": "12 months" };

export const OutcomeBoard = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/outcomes").then((r) => setData(r.data)).catch(() => {}); }, []);
  return (
    <section className="py-20 bg-[#f8f4e8]" data-testid="outcome-board">
      <div className="dk-container">
        <span className="text-[#d6aa43] tracking-[0.3em] text-xs font-semibold uppercase">Output · Outcome · Impact</span>
        <h2 className="font-serif text-3xl md:text-5xl font-bold mt-3 text-[#0a0d12]">We separate what we delivered from what actually changed.</h2>
        <p className="text-[#0a0d12]/70 mt-3 max-w-2xl">Every intervention is followed up at 3, 6 and 12 months. Outputs are easy to count; outcomes and impact are what we are accountable for.</p>
        <div className="grid md:grid-cols-3 gap-5 mt-10">
          {LEVELS.map(([key, title, sub, eg]) => {
            const periods = data?.board?.[key] || {};
            const total = Object.values(periods).reduce((a, b) => a + b.length, 0);
            return (
              <div key={key} className="bg-white rounded-2xl border border-black/5 p-6 flex flex-col" data-testid={`outcome-col-${key}`}>
                <div className="flex items-baseline justify-between"><h3 className="font-serif text-2xl font-bold">{title}</h3><span className="text-xs font-mono text-[#0a0d12]/60" data-testid={`outcome-count-${key}`}>{total} measures</span></div>
                <div className="text-xs uppercase tracking-wider text-[#d6aa43] font-semibold mt-1">{sub}</div>
                <p className="text-xs text-[#0a0d12]/60 mt-1 italic">{eg}</p>
                <div className="mt-4 space-y-3 flex-1">
                  {["completion", "3m", "6m", "12m"].map((p) => (
                    <div key={p} data-testid={`outcome-${key}-${p}`}>
                      <div className="flex justify-between text-[10px] uppercase tracking-wider font-bold text-[#0a0d12]/60"><span>{PERIOD_LABEL[p]}</span><span>{(periods[p] || []).length}</span></div>
                      <ul className="mt-1 space-y-1">{(periods[p] || []).slice(0, 3).map((m) => <li key={m.id} className="text-sm bg-[#f8f4e8] rounded-md px-3 py-2"><span className="text-[#0a0d12]/70">{m.metric}:</span> <b>{m.value}</b><div className="text-[10px] font-mono text-[#0a0d12]/40">{m.subject_serial} · {p}</div></li>)}{(periods[p] || []).length === 0 && <li className="text-xs text-[#0a0d12]/55">No verified measures published yet.</li>}</ul>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
        <p className="text-xs text-[#0a0d12]/60 mt-6">Only verified figures are shown. We do not publish placeholder or estimated impact numbers.</p>
      </div>
    </section>
  );
};
